import { render } from "./ContactInfos.vue?vue&type=template&id=6694f945&scoped=true"
import script from "./ContactInfos.vue?vue&type=script&lang=js"
export * from "./ContactInfos.vue?vue&type=script&lang=js"

import "./ContactInfos.vue?vue&type=style&index=0&id=6694f945&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6694f945"]])

export default __exports__